export const i18nMessages = {
  error: {
    title: 'Ops..',
    message: 'Ocorreu um erro inesperado. Aguarde alguns minutos e tente novamente',
  },
  fetch_error: {
    title: 'Something went wrong...',
    message: 'Please, try again or contact support',
  },
  unauthorized: {
    title: 'Sem autorização',
    message: 'Você não tem permissão para essa ação',
  },
  model_not_found: {
    title: 'Modelo não foi encontrado.',
    message: 'Ocorreu um erro inesperado. Aguarde alguns minutos e tente novamente.',
  },
  success: {
    title: 'Sucesso!',
    message: 'Operação realizada com sucesso',
  },
  info: {
    title: 'Informação',
    message: 'Operação realizada.',
  },
  warning: {
    title: 'Atenção',
    message: 'Algo não saiu como esperado',
  },
  create: {
    title: 'Successo!',
    message: '{{item}} criado(a) com sucesso',
  },
  delete: { title: 'Successo!', message: '{{item}} deletado(a) com sucesso' },
  edit: {
    title: 'Successo!',
    message: 'Mudanças aplicadas com sucesso!',
  },
  conflict: {
    title: 'Ops..',
    message: 'Houve um conflito ao realizar a operação, tente novamente',
  },
  server_error: {
    title: 'Ops..',
    message: 'Erro interno do servidor',
  },
  validation_error: {
    title: 'Erro de validação',
    message:
      'Houve um erro de validação ao realizar a operação, verifique os dados e tente novamente',
  },
  auth_error: {
    title: 'Ops..',
    message:
      'Ocorreu um erro durante a etapa de autenticação. Aguarde alguns minutos e tente novamente',
  },
  '404': {
    title: 'Página não encontrada',
    message:
      'Por favor tente voltar para a página anterior ou entre em contato com o suporte da Shape.',
    action: 'Ir para a página inicial',
  },
  new_event_alert: {
    title: 'Novo Evento',
    message: 'O Evento {{eventId}} foi criado para o equipamento {{asset}}',
  },
  form_error: {
    title: 'Ops..',
    message:
      'Desculpe, não é possível salvar porque alguns campos estão faltando ou incorretos. Verifique os seguintes itens abaixo antes de salvar.',
    required: 'é obrigatório',
    special_character: 'Caracteres especiais não são permitidos',
  },
  workspaceError: {
    title: 'Erro',
    message: 'Seu usuário não possui um workspace registrado',
  },
  no_data: {
    title: 'Sem dados',
    message: 'Não há dados para mostrar',
  },
  copied_id_success: {
    message: 'ID copiado',
  },
  login_email_error: {
    title: 'Erro',
    message: 'Este email não é válido ou não está registrado para este cliente',
  },
  api_errors: {
    403: {
      title: 'Erro de Permissão',
      message: 'Você não tem permissão para acessar as informações relacionadas a este ativo',
    },
  },
  prevent_edit_leave: {
    title: 'Sair sem salvar?',
    message:
      'Alguns campos nesta página foram editados. Se você prosseguir, esses dados serão perdidos.',
    confirmLabel: 'Sim, sair',
    cancelLabel: 'Cancelar',
  },
};
